﻿import {GameManager} from "../../Game/GameManager";
import {Core} from "../../Base/Core";
import {PlayerPrefs} from "../../Utils/Unity/PlayerPrefs";
import {UIImage} from "../Tools/Base/UIImage";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UIText} from "../Tools/Base/UIText";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UISprite} from "../Tools/Base/UISprite";

const PREFS_PLANET_ID = "sjdhfn84ew7yfn78134134";
const PREFS_PLANET_SHOWN_PREFIX = "difygc34ne98rtycnerfcefcr";
const PRODUCT_ID = "skip_epochs_offer";

class EpochOffer extends UISprite {
    constructor() {
        super();

        this.planetImg = this.addChild(new UIImage());
        this.creatures = [];
        this.arrows = [this.addChild(new UIImage("arrow-green")), this.addChild(new UIImage("arrow-green"))];
    }

    _clearCreatures() {
        while (this.creatures.length) {
            this.removeChild(this.creatures.shift());
        }
    }

    Show(planet, creatures) {
        this.planetImg.setImage(`map/planet${planet.id}`);
        this._clearCreatures();
        for (let i = 0; i < 3; i++) {
            this.creatures.push(this.addChild(new UIImage(creatures[i] ? `creatures/${creatures[i]}` : "questionmark-ico")));
        }
    }

    fitLayout(parentRect) {
        this.position.copyFrom(parentRect);

        let rect = parentRect.clone();
        rect.width = parentRect.width * 0.9;
        rect.height = parentRect.height * 0.8;
        rect.x = (parentRect.width - rect.width) * 0.5;
        rect.y = (parentRect.height - rect.height) * 1;
        this.planetImg.fitRect(rect);

        rect = parentRect.clone();
        rect.width = parentRect.height * 0.2;
        rect.height = parentRect.height * 0.2;
        rect.x = (parentRect.width - rect.width) * 0;
        rect.y = (parentRect.height - rect.height) * 0.12;
        this.creatures[0].fitRect(rect);

        rect.x = (parentRect.width - rect.width) * 0.5;
        rect.y = (parentRect.height - rect.height) * 0;
        this.creatures[1].fitRect(rect);

        rect.x = (parentRect.width - rect.width) * 0.95;
        rect.y = (parentRect.height - rect.height) * 0.12;
        this.creatures[2].fitRect(rect);

        rect = parentRect.clone();
        rect.width = parentRect.width * 0.17;
        rect.height = parentRect.height * 0.12;
        rect.x = (parentRect.width - rect.width) * 0.25;
        rect.y = (parentRect.height - rect.height) * 0.1;
        this.arrows[0].fitRect(rect);
        this.arrows[0].rotation = -Math.PI / 9;

        rect.x = (parentRect.width - rect.width) * 0.75;
        this.arrows[1].fitRect(rect);
        this.arrows[1].rotation = Math.PI / 9;
    }
}

export class UISkipEpochsOffer extends UICommonPopup {
    get RequestedPlanetId() {
        return PlayerPrefs.GetInt(PREFS_PLANET_ID, 0);
    }

    set RequestedPlanetId(value) {
        PlayerPrefs.SetInt(PREFS_PLANET_ID, value);
    }

    isOfferShownForPlanet(planetId) {
        return PlayerPrefs.HasKey(PREFS_PLANET_SHOWN_PREFIX + planetId);
    }

    onOfferShownForPlanet(planetId) {
        PlayerPrefs.SetInt(PREFS_PLANET_SHOWN_PREFIX + planetId, 1);
    }

    get available() {
        return Core.Store.ProductAvailable(PRODUCT_ID, false);
    }

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("offer_skipepochs_title"),
            closeButton: true,
            skin: "magenta",
        });

        this.onProductPurchased = this.onProductPurchased.bind(this);

        this.epochOffer = this.content.addChild(new EpochOffer());

        this.description = this.content.addChild(new UIText(Core.Localizator.Get("offer_skipepochs_desc")));
        this.btnBuy = this.content.addChild(new UINineSliceButton("btn-orange", { label: "" }));
        this.btnBuy.on("pointertap", () => {
            Core.Store.BuyProductID(PRODUCT_ID);
        });

        Core.Store.on("Purchased", this.onProductPurchased);
    }

    Init() {
        if (!this.available) {
            this.SetActive(false);
            return;
        }
        super.Init();
        this.btnBuy.label = Core.Store.GetProduct(PRODUCT_ID).GetPrice();
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.6;
        let w = Math.min(viewport.width * 0.85, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.width = contentRect.width * 0.9;
        rect.height = contentRect.height * 0.55;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.3;
        this.epochOffer.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.8;
        rect.height = contentRect.height * 0.05;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.75;
        this.description.fitLayout(rect);

        rect = contentRect.clone();
        rect.width = contentRect.width * 0.46;
        rect.height = contentRect.height * 0.14;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.95;
        this.btnBuy.fitLayout(rect);
    }

    onProductPurchased(product) {
        if (product.id == PRODUCT_ID) {
            this.Hide();
            if (Core.Player.PlanetsSave.CurrentPlanet.epochs.includes(2)) {
                GameManager.gameView.SelectEpoch(2, false, 1);
            }
            Core.Player.PlanetsSave.CurrentPlanet.CheckTapChallengeStatus();
        }
    }

    Show(planetId = this.RequestedPlanetId || Core.Player.PlanetsSave.CurrentPlanet.planetId) {
        if (planetId) this.RequestedPlanetId = planetId;

        if (!Core.Store.IsInitialized) return;
        if (!this.available) return;
        if (!Core.Player.Initialized) return;
        if (!this.RequestedPlanetId) return;

        let planet = Core.GameData.Planets.GetPlanet(this.RequestedPlanetId);
        let creatures = [Core.GameData.Epochs.GetById(1).creatures[0], Core.GameData.Epochs.GetById(2).creatures[0]];
        if (planet) {
            this.Init();
            this.epochOffer.Show(planet, creatures);
            super.Show();
        }
    }

    Check() {
        if (!this.available) return;
        if (Core.Player.PlanetsSave.currentPlanetId != 1) {
            if (Core.Player.PlanetsSave.CurrentPlanet.epochs.length == 1) {
                if (!this.isOfferShownForPlanet(Core.Player.PlanetsSave.currentPlanetId)) {
                    this.onOfferShownForPlanet(Core.Player.PlanetsSave.currentPlanetId);
                    Core.UI.ShowOrder(() => {
                        this.Show(Core.Player.PlanetsSave.currentPlanetId);
                    });
                }
            }
        }
    }
}
